import { render, staticRenderFns } from "./transaction-summary.vue?vue&type=template&id=316cba1c&scoped=true&"
import script from "./transaction-summary.vue?vue&type=script&lang=js&"
export * from "./transaction-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316cba1c",
  null
  
)

export default component.exports